import { render } from "./DeletePostComponent.vue?vue&type=template&id=036ecb9f&scoped=true&ts=true"
import script from "./DeletePostComponent.vue?vue&type=script&lang=ts"
export * from "./DeletePostComponent.vue?vue&type=script&lang=ts"

import "./DeletePostComponent.vue?vue&type=style&index=0&id=036ecb9f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036ecb9f"]])

export default __exports__